import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12" }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "m8.253 17.852-4.389-4.697c-.6-.643-.566-1.66.077-2.261s1.66-.566 2.261.076l3.386 3.624 5.358-5.007q.073-.067.15-.124l2.52-2.355c.644-.6 1.661-.566 2.262.077.6.643.566 1.66-.077 2.262l-7.696 7.19-.008-.008-2.663 2.487z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }